import React from "react";
import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import saveImg from "../../../assets/images/searchContact/saveImg.svg";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { ClearBtn, EditBtn } from "../../Buttons/Buttons";

const Flagged = () => {
    const data = [
        {
            name: "Lokesh Gupta",
            title: "Information Technology Director",
            company: "Bank Of Baroda",
            phone: "91-2266985004",
            email: "lokesh.gupta@bankofbaroda.com",
            industry: "Computer Programming",
            location: "New Jersey, United States"
        },
        {
            name: "Aamir Siddiqui",
            title: "DIRECTOR OF TECHNOLOGY",
            company: "Winpak Films Inc.",
            phone: "770-599-4622",
            email: "aamir.siddiqui@winpak.com",
            industry: "Rubber and Plastic Product Manufacturing",
            location: "Georgia, United States"
        },
        {
            name: "Aaron Andrus",
            title: "Director, Information Systems And Security",
            company: "Agreserves Inc.",
            phone: "1-801-715-9100",
            email: "aandrus@agreserves.com",
            industry: "Crop and Animal Production",
            location: "Utah, United States"
        },
        {
            name: "Aaron Wooden",
            title: "Chief Financial Officer",
            company: "Bae Systems Inc.",
            phone: "1-703-312-6100",
            email: "aaron.weedon@baesystems.com",
            industry: "Electromedical and Control Instruments Manufacturing",
            location: "Virginia, United States"
        },
        {
            name: "Aaron Sackstein",
            title: "Chief Financial Officer",
            company: "Bellco Glass Inc",
            phone: "1-800-257-7043",
            email: "asackstein@bellcoglass.com",
            industry: "Medical Equipment and Supplies",
            location: "New Jersey, United States"
        }
    ];

    return (
        <div className="page-layout">
            <AppNavbar />
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>Flagged</p>
                            <div className="saved-search-img-div">
                                <h5>Contacts</h5>
                                <img src={saveImg} alt="Save" />
                            </div>
                        </div>
                    </div>

                    <TableContainer component={Paper} className="flagged-contact-table">
                        <Table aria-label="contact table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ minWidth: "180px" }}>Contact</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Title</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Company</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Phone</TableCell>
                                    <TableCell style={{ minWidth: "200px" }}>Email</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Industry</TableCell>
                                    <TableCell style={{ minWidth: "180px" }}>Location</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.map((row) => (
                                    <TableRow key={row.name}>
                                        <TableCell>{row.name}</TableCell>
                                        <TableCell>{row.title}</TableCell>
                                        <TableCell>{row.company}</TableCell>
                                        <TableCell>
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="fa-solid fa-phone"></i> &nbsp;{row.phone}
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <div className="d-flex align-items-center gap-2">
                                                <i className="fa-solid fa-envelope"></i> &nbsp;{row.email}
                                            </div>
                                        </TableCell>
                                        <TableCell>{row.industry}</TableCell>
                                        <TableCell>{row.location}</TableCell>
                                        <TableCell >
                                            <div className="d-flex gap-2">
                                                <EditBtn btnName='Edit' />
                                                <ClearBtn btnName='Verify' />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Flagged;
